import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryLookBookGoodss(
  {
    page, size, direction, sort, lookBookId,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-goods`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      lookBookId,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryLookBookGoods(lookBookGoodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-goods/${lookBookGoodsId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  lookBookId
 * @param  goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addLookBookGoodsList(
  {
    lookBookId,
    goodsIds,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-goods-list`,
    method: 'post',
    data: {
      lookBookId,
      goodsIds,
    },
  });
}
export function _addLookBookGoods(
  {
    lookBookId,
    goodsId,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-goods`,
    method: 'post',
    data: {
      lookBookId,
      goodsId,
    },
  });
}
/**
 * 更新
 * @param lookBookGoodsId
 * @param  lookBookId
 * @param  goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateLookBookGoods(lookBookGoodsId, {
  lookBookId,
  goodsId,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-goods/${lookBookGoodsId}`,
    method: 'patch',
    data: {
      lookBookId,
      goodsId,
    },
  });
}

export function _updateLookBookGoodsList(lookBookGoodsId, {
  lookBookId,
  goodsIds,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-goods-list/${lookBookGoodsId}`,
    method: 'post',
    data: {
      lookBookId,
      goodsIds,
    },
  });
}

/**
 * 删除
 * @param lookBookGoodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteLookBookGoods(lookBookGoodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-goods/${lookBookGoodsId}`,
    method: 'delete',
  });
}

/**
 * 上移
 * @param goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upLookBookGoods(lookBookGoodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-goods/${lookBookGoodsId}/up`,
    method: 'patch',
  });
}

/**
 * 下移
 * @param goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downLookBookGoods(lookBookGoodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-book-goods/${lookBookGoodsId}/down`,
    method: 'patch',
  });
}

export default {};
